export const CLEAR_NOTICE = 'CLEAR_NOTICE';
export const CLEAR_NOTICES = 'CLEAR_NOTICES';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_NOTICE = 'DELETE_NOTICE';
export const DELETE_NOTICE_ERROR = 'DELETE_NOTICE_ERROR';
export const DELETE_NOTICE_SUCCESS = 'DELETE_NOTICE_SUCCESS';

export const GET_RECURRENCY = 'GET_RECURRENCY';
export const GET_RECURRENCY_ERROR = 'GET_RECURRENCY_ERROR';
export const GET_RECURRENCY_SUCCESS = 'GET_RECURRENCY_SUCCESS';

export const GET_NOTICE = 'GET_NOTICE';
export const GET_NOTICE_ERROR = 'GET_NOTICE_ERROR';
export const GET_NOTICE_SUCCESS = 'GET_NOTICE_SUCCESS';

export const GET_NOTICES = 'GET_NOTICES';
export const GET_NOTICES_ERROR = 'GET_NOTICES_ERROR';
export const GET_NOTICES_SUCCESS = 'GET_NOTICES_SUCCESS';

export const SAVE_NOTICE = 'SAVE_NOTICES';
export const SAVE_NOTICE_ERROR = 'SAVE_NOTICES_ERROR';
export const SAVE_NOTICE_SUCCESS = 'SAVE_NOTICES_SUCCESS';

export const CREATE_NOTICE = 'CREATE_NOTICE';
export const CREATE_NOTICE_ERROR = 'CREATE_NOTICE_ERROR';
export const CREATE_NOTICE_SUCCESS = 'CREATE_NOTICE_SUCCESS';

export const SEND_MAILTO_USER = 'SEND_MAILTO_USER';
export const SEND_MAILTO_USER_SUCCESS = 'SEND_MAILTO_USER_SUCCESS';
export const SEND_MAILTO_USER_ERROR = 'SEND_MAILTO_USER_ERROR';

export const SEND_TO = 'SEND_TO_USER';
export const SEND_TO_SUCCESS = 'SEND_TO_SUCCESS';
export const SEND_TO_ERROR = 'SEND_TO_ERROR';

export const GET_COOWNERS_FIELDS = 'GET_COOWNERS_FIELDS';
export const GET_COOWNERS_FIELDS_SUCCESS = 'GET_COOWNERS_FIELDS_SUCCESS';
export const GET_COOWNERS_FIELDS_ERROR = 'GET_COOWNERS_FIELDS_ERROR';

export const GET_COOWNERS_USER = 'GET_COOWNERS_USER ';
export const GET_COOWNERS_USER_ERROR = 'GET_COOWNERS_USER_ERROR';
export const GET_COOWNERS_USER_SUCCESS = 'GET_COOWNERS_FUSER_SUCCESS';

export const SEND_NOTICE = 'SEND_NOTICE';
export const SEND_NOTICE_ERROR = 'SEND_NOTICE_ERROR';
export const SEND_NOTICE_SUCCESS = 'SEND_NOTICE_SUCCESS';

export const GET_CUSTOM_PLACEHOLDER = 'GET_CUSTOM_PLACEHOLDER';
export const GET_CUSTOM_PLACEHOLDER_ERROR = 'GET_CUSTOM_PLACEHOLDER_ERROR';
export const GET_CUSTOM_PLACEHOLDER_SUCCESS = 'GET_CUSTOM_PLACEHOLDER_SUCCESS';

export const UPDATE_NOTICE_MAIL = 'UPDATE_NOTICE_MAIL';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Notices/constants.js